import { observable } from 'mobx'
import RequestStatus from 'todistukset-ui/src/vtj/RequestStatus.enum'

export const createOrderStatus = () =>
  observable({
    requestStatus: RequestStatus.INPUT,
  })
